import { useMemo } from 'react';
function formatOwnerText(owner) {
  var _owner$email;
  const parts = [owner.firstName, owner.lastName].filter(p => Boolean(p));
  return parts.length > 0 ? parts.join(' ') : (_owner$email = owner.email) !== null && _owner$email !== void 0 ? _owner$email : '';
}
function formatOwnerSearchText(owner) {
  const name = formatOwnerText(owner);
  return owner.email && name !== owner.email ? `${name} (${owner.email})` : name;
}
export function useAtMentionOptions(owners, teams) {
  const ownerOptions = useMemo(() => {
    if (!owners) {
      return [];
    }
    return owners.filter(o => o.isActive !== false).map(o => {
      const searchText = formatOwnerSearchText(o);
      return {
        id: o.ownerId,
        searchText,
        text: formatOwnerText(o),
        value: String(o.ownerId),
        type: 'OWNER',
        email: searchText
      };
    }).sort((a, b) => a.searchText.localeCompare(b.searchText));
  }, [owners]);
  const teamOptions = useMemo(() => {
    if (!teams) {
      return [];
    }
    return teams.map(t => {
      const doesTeamHaveUsers = t.userIds && t.userIds.length > 0 || t.secondaryUserIds && t.secondaryUserIds.length > 0;
      return Object.assign({
        id: t.id,
        searchText: t.searchText,
        text: t.text,
        value: t.value,
        type: 'TEAM',
        userIds: t.userIds,
        disabled: !doesTeamHaveUsers
      }, t.secondaryUserIds && {
        secondaryUserIds: t.secondaryUserIds
      });
    });
  }, [teams]);
  const allOptions = useMemo(() => [...ownerOptions, ...teamOptions], [ownerOptions, teamOptions]);
  return {
    ownerOptions,
    teamOptions,
    allOptions
  };
}